import * as React from 'react';
var WixStylesContext = React.createContext({
    calendarAlignmentWeeklyIsLeft: false,
    eventTitleFontFamily: 'Arial, Helvetica, sans-serif',
    eventTitleFont: {},
    eventTimeFont: {},
    calendarBackgroundColorWithoutOpacity: 'white',
    cellBorderColor: 'lightgray',
    eventTitleFontSize: 14,
    eventTimeFontSize: 14,
    cellBorderWidth: 1,
    todayBorderColor: 'rgba(0,87,225,1)',
    isCurrentTimeIndicator: true,
    currentTimeLineColor: 'rgb(237, 88, 41)',
    isCurrentTimeShown: true,
    is24format: true,
    isResponsive: true,
    isGoogleColor: 0,
    isTimeShown: true,
    googleCalendarColors: false,
    timezoneFontSize: 16,
    isWeekFontMoreTwantyFive: false,
    isWeekFontMoreTwanty: false,
    isCalendarsFontMoreTwanty: false,
    isHeaderFontMoreTwanty: false,
    fontMoreTwantySeven: false,
    indicatorWidth: 2,
    isLeft: false,
    mobile_weeklyHoursFontSize: 12,
    todayBtnStyles: 1,
    hoursTextFont: {},
    weeklyMonthDayFont: {},
    weekDaysFont: {},
});
export default WixStylesContext;
//# sourceMappingURL=wixStylesContext.js.map